// Benchmarking View Component - Workflow-based cell selection
import { useEffect } from 'preact/hooks'
import { trackPlotView } from '../../modules/dataService.js'
import BenchmarkingWorkflow from './BenchmarkingWorkflow.jsx'

export default function BenchmarkingView() {
  // Track benchmarking view when component mounts
  useEffect(() => {
    trackPlotView('benchmarking', 'benchmarking')
  }, [])

  return (
    <div className="benchmarking-view benchmarking-view--workflow">
      <BenchmarkingWorkflow />
    </div>
  )
}
